import { HTMLProps, useEffect, useRef } from 'react'

import { useWindowDimensions } from 'hooks/UseWindowDimensions'

export const ExpandingTextArea = ({ value, ...textAreaProps }: HTMLProps<HTMLTextAreaElement>) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null)
  const windowDimensions = useWindowDimensions()

  const resizeTextArea = () => {
    if (textAreaRef.current) {
      const textArea = textAreaRef.current

      textArea.style.height = '1px'
      textArea.style.height = `${textArea.scrollHeight}px`
    }
  }

  useEffect(resizeTextArea, [value, windowDimensions])

  return <textarea ref={textAreaRef} value={value} {...textAreaProps} />
}
